document.addEventListener("DOMContentLoaded", () => {
  // 1. Collect all resources across multiple sections
  const resourcesSections = document.querySelectorAll('[data-resources-section]');
  if (resourcesSections.length === 0) return;

  // The first section will act as our master UI
  const masterSection = resourcesSections[0];
  const masterGrid = masterSection.querySelector('[data-resources-grid]');

  // Move all resources from subsequent sections into the master grid
  for (let i = 1; i < resourcesSections.length; i++) {
    const section = resourcesSections[i];

    // Find blocks
    const cards = section.querySelectorAll('[data-resource-card]');
    cards.forEach(card => {
      masterGrid.appendChild(card);
    });

    // Hide the dummy section's layout completely
    const layout = section.querySelector('[data-resources-layout]');
    if (layout) {
      layout.style.display = 'none';
    }
  }

  // 2. Setup State for Filter and Pagination
  let allCards = Array.from(masterGrid.querySelectorAll('[data-resource-card]'));
  let filteredCards = [...allCards];

  let activeFilters = []; // array of {group, value}
  let searchQuery = '';

  const itemsPerPage = parseInt(masterGrid.getAttribute('data-items-per-page')) || 12;
  let currentPage = 1;

  // Elements
  const searchInput = masterSection.querySelector('[data-resource-search]');
  const filterInputs = masterSection.querySelectorAll('[data-filter-input]');
  const appliedContainer = masterSection.querySelector('[data-applied-filters]');
  const appliedTags = masterSection.querySelector('[data-applied-tags]');
  const clearAllBtn = masterSection.querySelector('[data-clear-all]');
  const noResults = masterSection.querySelector('[data-no-results]');
  const paginationContainer = masterSection.querySelector('[data-pagination-container]');
  const paginationDots = masterSection.querySelector('[data-pagination-dots]');

  // Overlay Elements for Mobile Drawer
  const sidebar = masterSection.querySelector('[data-sidebar]');
  const overlay = masterSection.querySelector('[data-sidebar-overlay]');
  const openBtns = masterSection.querySelectorAll('[data-sidebar-open]');
  const closeBtns = masterSection.querySelectorAll('[data-sidebar-close]');

  // Mobile Drawer Setup
  const toggleSidebar = (forceClose) => {
    const isCurrentlyOpen = sidebar.classList.contains('is-open');
    const shouldClose = forceClose !== undefined ? forceClose : isCurrentlyOpen;

    sidebar.classList.toggle('is-open', !shouldClose);
    overlay.classList.toggle('is-active', !shouldClose);

    if (!shouldClose) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  if (openBtns) {
    openBtns.forEach(btn => btn.addEventListener('click', () => toggleSidebar(false)));
  }
  if (closeBtns) {
    closeBtns.forEach(btn => btn.addEventListener('click', () => toggleSidebar(true)));
  }
  if (overlay) {
    overlay.addEventListener('click', () => toggleSidebar(true));
  }

  // Search logic
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value.toLowerCase().trim();
      currentPage = 1; // reset page on search
      applyFilters();
    });
  }

  // Filter Logic
  masterSection.addEventListener('change', (e) => {
    if (e.target.matches('[data-filter-input]')) {
      const input = e.target;
      const val = input.value;
      const groupEl = input.closest('[data-filter-group]');
      const group = groupEl.getAttribute('data-filter-group');
      const type = groupEl.getAttribute('data-display-type') || 'checkbox';

      if (type === 'radio') {
        // Remove existing for this group
        activeFilters = activeFilters.filter(f => f.group !== group);
        if (input.checked) {
          activeFilters.push({ group, value: val });
        }
      } else {
        // checkbox
        if (input.checked) {
          activeFilters.push({ group, value: val });
        } else {
          activeFilters = activeFilters.filter(f => f.value !== val || f.group !== group);
        }
      }
      currentPage = 1;
      applyFilters();
    } else if (e.target.matches('[data-filter-select]')) {
      const select = e.target;
      const groupEl = select.closest('[data-filter-group]');
      const group = groupEl.getAttribute('data-filter-group');
      const val = select.value;

      activeFilters = activeFilters.filter(f => f.group !== group);
      if (val !== '') {
        activeFilters.push({ group, value: val });
      }
      currentPage = 1;
      applyFilters();
    }
  });

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', () => {
      activeFilters = [];

      // clear checkboxes and radios
      masterSection.querySelectorAll('[data-filter-input]').forEach(i => i.checked = false);
      // clear selects
      masterSection.querySelectorAll('[data-filter-select]').forEach(s => s.value = '');

      if (searchInput) {
        searchInput.value = '';
        searchQuery = '';
      }
      currentPage = 1;
      applyFilters();
    });
  }

  function applyFilters() {
    filteredCards = allCards.filter(card => {
      const title = card.getAttribute('data-title') || '';
      const descStr = card.querySelector('.resource-description')?.innerText.toLowerCase() || '';
      const tagStr = card.querySelector('.resource-tag')?.innerText.toLowerCase() || '';

      // Allow comma or format from liquid
      const filterData = card.getAttribute('data-filters') || '';
      const cardTags = filterData.split(',').map(t => t.trim().toLowerCase());

      // Text Search
      const textMatch = (title.includes(searchQuery) || descStr.includes(searchQuery) || tagStr.includes(searchQuery));
      if (!textMatch) return false;

      // Checkbox filters (OR within group, AND across groups)
      const groups = [...new Set(activeFilters.map(f => f.group))];

      const groupMatch = groups.every(grp => {
        const groupValues = activeFilters.filter(f => f.group === grp).map(f => f.value.toLowerCase());
        // Does this card have at least one of these values?
        return groupValues.some(v => cardTags.includes(v));
      });

      if (groups.length > 0 && !groupMatch) return false;

      return true;
    });

    renderAppliedTags();
    renderGrid();
  }

  function renderAppliedTags() {
    if (!appliedContainer) return;

    if (activeFilters.length === 0) {
      appliedContainer.style.display = 'none';
    } else {
      appliedContainer.style.display = 'block';
      appliedTags.innerHTML = activeFilters.map(f => `
                <div class="applied-tag">
                    ${f.value}
                    <svg data-remove="${f.value}" data-group="${f.group}" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.575 7.975L1.675 12.875C1.49167 13.0583 1.25833 13.15 0.975 13.15C0.691667 13.15 0.458333 13.0583 0.275 12.875C0.0916663 12.6917 0 12.4583 0 12.175C0 11.8917 0.0916663 11.6583 0.275 11.475L5.175 6.575L0.275 1.675C0.0916663 1.49167 0 1.25833 0 0.975C0 0.691667 0.0916663 0.458333 0.275 0.275C0.458333 0.0916663 0.691667 0 0.975 0C1.25833 0 1.49167 0.0916663 1.675 0.275L6.575 5.175L11.475 0.275C11.6583 0.0916663 11.8917 0 12.175 0C12.4583 0 12.6917 0.0916663 12.875 0.275C13.0583 0.458333 13.15 0.691667 13.15 0.975C13.15 1.25833 13.0583 1.49167 12.875 1.675L7.975 6.575L12.875 11.475C13.0583 11.6583 13.15 11.8917 13.15 12.175C13.15 12.4583 13.0583 12.6917 12.875 12.875C12.6917 13.0583 12.4583 13.15 12.175 13.15C11.8917 13.15 11.6583 13.0583 11.475 12.875L6.575 7.975Z" fill="white"/>
                    </svg>
                </div>
            `).join('');

      // attach removal
      appliedTags.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const val = btn.getAttribute('data-remove');
          const grp = btn.getAttribute('data-group');
          activeFilters = activeFilters.filter(f => f.value !== val || f.group !== grp);

          // uncheck input
          const input = Array.from(masterSection.querySelectorAll('[data-filter-input]')).find(i => i.value === val && i.closest('[data-filter-group]').getAttribute('data-filter-group') === grp);
          if (input) input.checked = false;

          // clear select
          const select = Array.from(masterSection.querySelectorAll('[data-filter-select]')).find(s => s.closest('[data-filter-group]').getAttribute('data-filter-group') === grp);
          if (select) select.value = '';

          currentPage = 1;
          applyFilters();
        });
      });
    }
  }

  function renderGrid() {
    // Toggle No Results
    if (filteredCards.length === 0) {
      masterGrid.style.display = 'none';
      if (noResults) noResults.style.display = 'block';
      if (paginationContainer) paginationContainer.style.display = 'none';
      return;
    } else {
      masterGrid.style.display = 'flex';
      if (noResults) noResults.style.display = 'none';
    }

    // Hide all cards first
    allCards.forEach(card => card.style.display = 'none');

    // Calculate pagination bounds
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Show cards for current page
    const pageCards = filteredCards.slice(startIndex, endIndex);
    pageCards.forEach(card => card.style.display = 'flex');

    // Render Pagination Dots
    renderPagination();
  }

  function renderPagination() {
    if (!paginationContainer || !paginationDots) return;

    const totalPages = Math.ceil(filteredCards.length / itemsPerPage);

    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    }

    paginationContainer.style.display = 'flex';

    let dotsHTML = '';
    for (let i = 1; i <= totalPages; i++) {
      dotsHTML += `<span class="dot ${i === currentPage ? 'active' : ''}" data-page="${i}"></span>`;
    }
    paginationDots.innerHTML = dotsHTML;

    // attach click events
    paginationDots.querySelectorAll('.dot').forEach(dot => {
      dot.addEventListener('click', (e) => {
        currentPage = parseInt(dot.getAttribute('data-page'));
        renderGrid();
        // scroll to top of section smoothly
        masterSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // Initial render
  renderGrid();
});
